import { StringFormatter } from '@utils/stringFormatter';
import dateFormat from 'date-fns/format';
import add from 'date-fns/add';
import differenceInDays from 'date-fns/differenceInDays';

const buildRequestBlockedMessage = (detail: string, reason: string, windowsDurationSec?: number): string => {
    if (!windowsDurationSec) return reason;
    return reason + '\n\n' + buildRequestBlockedDetail(detail, windowsDurationSec);
};

const buildRequestBlockedDetail = (detail: string, windowsDurationSec: number) => {
    let timeFormat = 'HH:mm';
    const currentTimeStamp = new Date();
    const blockedTimeStamp = getBlockTime(currentTimeStamp, windowsDurationSec);
    if (differenceInDays(blockedTimeStamp, currentTimeStamp) > 0) timeFormat = 'MMM d HH:mm';
    return StringFormatter.format(detail, dateFormat(blockedTimeStamp, timeFormat));
};

const getBlockTime = (currentTimeStamp: Date, seconds: number) => {
    return add(currentTimeStamp, {
        seconds,
    });
};

export { buildRequestBlockedMessage };
